import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdmodalCalender from "../Calendar/EdmodalCalender";
import { getDateInFormat, getDefaultDateRanges, } from "@domains/utils/reportDates";
import moment from "moment";
import DeviceContext from "../customHooks/indentifyDevice";
const CustomDateFilter = (props) => {
    const device = DeviceContext();
    const [edModalCalender, setEdModalCalender] = useState(false);
    const [dateRange, setDateRange] = useState({
        startDate: "",
        endDate: "",
    });
    const handleDateChange = (startDate, endDate) => {
        let formattedStartDate = getDateInFormat(startDate, "DD-MMM-YYYY");
        let formattedEndDate = getDateInFormat(endDate, "DD-MMM-YYYY");
        setDateRange(() => {
            return {
                startDate: formattedStartDate,
                endDate: formattedEndDate,
            };
        });
        props === null || props === void 0 ? void 0 : props.applyDate(`${formattedStartDate}to${formattedEndDate}`);
        setEdModalCalender(false);
    };
    useEffect(() => {
        if (props.customDateFilter) {
            let date = props.customDateFilter.split("to");
            setDateRange({
                startDate: date[0],
                endDate: date[1],
            });
        }
        else {
            setDateRange(getDefaultDateRanges(1, "DD-MMM-YYYY"));
        }
    }, [props.customDateFilter]);
    return (React.createElement(Row, { className: "mx-0 pt-3" },
        React.createElement(Col, { lg: 12 },
            React.createElement("div", null,
                React.createElement("div", { className: "common-fromToDate-picker" },
                    React.createElement("div", { className: "col-md-12 col-lg-12 pandLcalendar-form" },
                        React.createElement("div", { className: device && device.isDesktop
                                ? "row calendar--row grid-2 gap-20"
                                : "row calendar--row grid-1 gap-20" },
                            React.createElement("div", { className: device && device.isDesktop
                                    ? "col pdr-md-0"
                                    : "col pdr-md-0 ps-0 pe-5" },
                                React.createElement("label", { htmlFor: "", className: "DMSanM_14_500 txt_secondary-gray mb-10" }, "From Date"),
                                React.createElement("div", { className: "input-group" },
                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-YY", defaultValue: dateRange.startDate }),
                                    React.createElement("span", { className: "input-group-text", onClick: () => {
                                            setEdModalCalender(true);
                                        } },
                                        React.createElement("i", { className: "edel-icon-calendar-report" })))),
                            React.createElement("div", { className: device && device.isDesktop
                                    ? "col pdr-md-0"
                                    : "col pdr-md-0 ps-0 pe-5" },
                                React.createElement("label", { htmlFor: "", className: "DMSanM_14_500 txt_secondary-gray mb-10" }, "To Date"),
                                React.createElement("div", { className: "input-group" },
                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-YY", defaultValue: dateRange.endDate }),
                                    React.createElement("span", { className: "input-group-text", onClick: () => {
                                            setEdModalCalender(true);
                                        } },
                                        React.createElement("i", { className: "edel-icon-calendar-report" }))))))))),
        edModalCalender && (React.createElement(EdmodalCalender, { show: edModalCalender, setShow: setEdModalCalender, onDatesChange: handleDateChange, minDate: new Date(moment().subtract(6, "months").toString()), maxDate: new Date(), startDate: new Date(dateRange.startDate), endDate: new Date(dateRange.endDate), isApplyDisable: false, title: "Select Order Date" }))));
};
export default CustomDateFilter;
